module.exports = __webpack_public_path__ + "templates.tab-buttons-a2e994f2.html";